module.exports = __webpack_public_path__ + "img/s.87806fd3.jpg";